import { render, staticRenderFns } from "./GstReportSideMenu.vue?vue&type=template&id=06e5d953&scoped=true"
import script from "./GstReportSideMenu.vue?vue&type=script&lang=js"
export * from "./GstReportSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5d953",
  null
  
)

export default component.exports